import * as React from 'react';
import { Link } from 'react-router-dom';

import C from 'classnames';
import { TestingProps } from '../../Types/Testing';

interface INavLinkProps
  extends Partial<React.ComponentProps<Link>>,
    TestingProps {
  href?: string;
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  dropdown?: boolean;
  active?: boolean;
  tag?: any;
}

export const NavLink: React.FunctionComponent<INavLinkProps> = (props) => {
  const [toggled, setToggled] = React.useState(false);

  const onClick = () => {
    setToggled((d) => !d);
    props.onClick && props.onClick();
  };
  return props.to ? (
    <Link
      className={C(
        'nav-link',
        props.active && 'active',
        props.dropdown ? 'dropdown ' + (toggled ? 'expanded' : 'collapsed') : ''
      )}
      to={props.to}
      onClick={onClick}
      data-testid={props.testId}
    >
      {props.children}
    </Link>
  ) : (
    <a
      className={C(
        'nav-link',
        props.active && 'active',
        props.dropdown ? 'dropdown ' + (toggled ? 'expanded' : 'collapsed') : ''
      )}
      href={props.href}
      onClick={onClick}
      data-testid={props.testId}
    >
      {props.children}
    </a>
  );
};
